import React from "react"
import { captureException } from "../services/exception-logger"
import { ErrorFallbackUI } from "./ErrorFallbackUI"

type Props = {
  children: React.ReactNode
}

type State = {
  error: any
}

class ErrorBoundaryComponent extends React.Component<Props, State> {
  private promiseRejectionHandler = (event: PromiseRejectionEvent) => {
    this.setState({
      error: event.reason,
    })
  }

  public state: State = {
    error: null,
  }

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { error: error }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    captureException(error, {
      tags: {
        errorSource: "ErrorBoundary - web",
        errorInfo: JSON.stringify(errorInfo),
      },
    })
  }

  componentDidMount() {
    // Add an event listener to the window to catch unhandled promise rejections & stash the error in the state
    window.addEventListener("unhandledrejection", this.promiseRejectionHandler)
  }

  componentWillUnmount() {
    window.removeEventListener(
      "unhandledrejection",
      this.promiseRejectionHandler
    )
  }

  render() {
    if (this.state.error) {
      // You can render any custom fallback UI
      return <ErrorFallbackUI />
    }

    return this.props.children
  }
}

export default ErrorBoundaryComponent
